import { render, staticRenderFns } from "./ModalCadastroNivel.vue?vue&type=template&id=76209690"
import script from "./ModalCadastroNivel.vue?vue&type=script&lang=js"
export * from "./ModalCadastroNivel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports